module.exports = __webpack_public_path__ + "6dbff40a013fca32c2b51b97afeb2c68.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/skiis.png
// module id = 1944
// module chunks = 0